<template>
    <svg t="1568896685001" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="1495" width="200" height="200">
        <path d="M409.6 140.8A38.4 38.4 0 0 1 371.2 179.2H230.4a51.2 51.2 0 0 0-51.2 51.2v563.2a51.2 51.2 0 0 0 51.2 51.2h563.2a51.2 51.2 0 0 0 51.2-51.2v-140.8a38.4 38.4 0 0 1 76.8 0V819.2a102.4 102.4 0 0 1-102.4 102.4H204.8a102.4 102.4 0 0 1-102.4-102.4V204.8a102.4 102.4 0 0 1 102.4-102.4h166.4A38.4 38.4 0 0 1 409.6 140.8zM790.5024 179.2H652.8a38.4 38.4 0 0 1 0-76.8h230.4A38.4 38.4 0 0 1 921.6 140.8v230.4a38.4 38.4 0 0 1-76.8 0V233.4976l-305.664 305.664a38.4 38.4 0 0 1-54.272-54.3232L790.4768 179.2z" p-id="1496" fill="#8a8a8a">
        </path>
    </svg>
</template>

<script>
export default {
  name: 'shareIcon',
  components: {
  },
  created() {
  }
}
</script>
